import gql from 'graphql-tag';

const UPDATE_UNINSTALL_PROTECTION_CONFIG = gql`
  mutation($configType: String!, $configParams: JSON) {
    updateUninstallProtectionConfig(
      configType: $configType
      configParams: $configParams
    )
  }
`;

export { UPDATE_UNINSTALL_PROTECTION_CONFIG };
